// The Agent API has no `return_related_questions`, so the function asks the
// model to end with a "Related questions:" section and we split it back out.
// Keep in sync with RELATED_QUESTIONS_INSTRUCTION in perplexity-api.mjs.
//
// Shared with scripts/build-precomputed-answers.mjs so a precomputed answer is
// stored in the same shape a live one arrives in.
export function splitRelatedQuestions(text) {
  const match = text.match(
    /\n\s*(?:#{1,6}\s*)?\**Related questions:?\**\s*\n([\s\S]*)$/i
  );
  if (!match) return { content: text, relatedQuestions: [] };

  const relatedQuestions = match[1]
    .split('\n')
    .map(line => line.replace(/^\s*(?:[-*+•]|\d+[.)])\s*/, '').trim())
    .filter(line => line.length > 0)
    .slice(0, 5);

  return { content: text.slice(0, match.index).trimEnd(), relatedQuestions };
}
